export default "__VITE_ASSET__1NWFG4Kg__"